import * as React from 'react';

import SalesContract56 from './SalesContract56';

export const salesContract56 = () => <SalesContract56 />;

export default {
    title: 'Illustration|SalesContract56',
    component: SalesContract56,
    parameters: {
        notes: "`import SalesContract56 from 'box-ui-elements/es/illustration/SalesContract56';`",
    },
};
